export default __webpack_public_path__ + "static/media/google-play-black.6e53b8d2.svg";